import { createContext, useContext, type ReactNode } from 'react';
import type { Role, TreeDetail } from '../api/types.ts';
import { can } from '../lib/format.ts';

export interface TreeCtxValue {
  treeId: string;
  tree: TreeDetail;
  role: Role;
  /** Persona del árbol enlazada al usuario actual. */
  myPersonId: string | null;
  canEdit: boolean;
  isAdmin: boolean;
  /** Ruta absoluta dentro del árbol: path('/arbol') → /t/<id>/arbol */
  path: (sub?: string) => string;
}

const Ctx = createContext<TreeCtxValue | null>(null);

export function TreeProvider({ tree, children }: { tree: TreeDetail; children: ReactNode }) {
  const value: TreeCtxValue = {
    treeId: tree.id,
    tree,
    role: tree.role,
    myPersonId: tree.personId,
    canEdit: can(tree.role, 'editor'),
    isAdmin: can(tree.role, 'admin'),
    path: (sub = '') => `/t/${tree.id}${sub}`,
  };
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useTreeCtx(): TreeCtxValue {
  const v = useContext(Ctx);
  if (!v) throw new Error('useTreeCtx fuera de TreeProvider');
  return v;
}
